import { render, staticRenderFns } from "./AreaAtuacao.vue?vue&type=template&id=44b8d82c&scoped=true&"
import script from "./AreaAtuacao.vue?vue&type=script&lang=js&"
export * from "./AreaAtuacao.vue?vue&type=script&lang=js&"
import style0 from "./AreaAtuacao.vue?vue&type=style&index=0&id=44b8d82c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b8d82c",
  null
  
)

export default component.exports